import { createStyles, MantineTheme, rem } from "@mantine/core";

export const useStyles = createStyles((theme: MantineTheme) => ({
  emptyIcon: {
    opacity: 0.5,
  },

  emptyText: {
    color: theme.colors.dark[8],
  },

  container: {
    width: "100%",
    height: "100%",
    position: "relative",
    overflow: "hidden",
    touchAction: "none",
  },

  dragHelper: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 100,
    pointerEvents: "none",
  },

  helperBox: {
    background: "white",
    padding: `${rem(16)} ${rem(24)}`,
    borderRadius: theme.radius.sm,
    boxShadow: theme.shadows.md,
    textAlign: "center",
  },

  documentContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transformOrigin: "center",
    maxWidth: "100%",
    maxHeight: "100%",
    userSelect: "none",
  },

  pdfWrapper: {
    width: "100%",
    height: "100%",
  },

  iframe: {
    width: "100%",
    height: "100%",
    border: "none",
    background: "#fff",
  },

  pdfNote: {
    marginTop: theme.spacing.xs,
  },

  image: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
    pointerEvents: "none",
  },

  controlsBox: {
    position: "absolute",
    bottom: rem(16),
    left: rem(16),
    display: "flex",
    gap: theme.spacing.xs,
    background: "rgba(255, 255, 255, 0.8)",
    padding: theme.spacing.xs,
    borderRadius: theme.radius.xs,
    zIndex: 10,
  },

  controlButton: {
    width: rem(32),
    height: rem(32),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: theme.colors.dark[8],
    color: "white",
    border: "none",
    borderRadius: theme.radius.xs,
    cursor: "pointer",

    "&:hover": {
      background: theme.colors.dark[7],
    },
  },

  resetButton: {
    height: rem(32),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: theme.colors.dark[8],
    color: "white",
    border: "none",
    borderRadius: theme.radius.xs,
    cursor: "pointer",
    padding: `0 ${theme.spacing.xs}`,

    "&:hover": {
      background: theme.colors.dark[7],
    },
  },
}));
